<br data-testid="t-ratings-br-1752672977568-1" />
<div
    class="separator"
    data-testid="t-ratings-div-1752672977568-1"
>
    {{ 'mws.supplierratings' | i18n }}
</div>
<div
    class="row g-0 row-bordered m-3"
    data-testid="t-ratings-div-1752672977568-6"
>
    <div
        class="col-6 d-flex align-items-center"
        data-testid="t-ratings-div-1752672977568-3"
    >
        <div
            class="text-xlarge ms-auto pe-3"
            data-testid="t-ratings-div-1752672977568-2"
        >
            <img
                loading="lazy"
                [src]="'assets/img/beispiel.jpg'"
                alt=""
                class="ui-w-140"
                data-testid="t-ratings-img-1752672977568-1"
            />
        </div>
    </div>

    <div
        class="col-6"
        data-testid="t-ratings-div-1752672977568-5"
    >
        <h3
            class="ms-3 my-auto"
            data-testid="t-ratings-h3-1752672977568-1"
        >
            <div
                class="text-muted small"
                data-testid="t-ratings-div-1752672977568-4"
            >
                {{ 'mws.supplier' | i18n }}
            </div>
            &#64;TODO Rewe
        </h3>
    </div>
</div>

<div
    class="row text-center"
    data-testid="t-ratings-div-1752672977568-15"
>
    <div
        class="col-12 d-flex justify-content-center"
        data-testid="t-ratings-div-1752672977568-14"
    >
        <h2
            class="me-auto my-auto"
            data-testid="t-ratings-h2-1752672977568-1"
        >
            4.3
            <span
                class="text-muted"
                data-testid="t-ratings-span-1752672977568-1"
                >/ 5</span
            >
        </h2>
        <div
            class="message-date text-muted"
            style="font-size: 200%"
            data-testid="t-ratings-div-1752672977568-13"
        >
            <div
                class="ui-stars text-large text-nowrap"
                data-testid="t-ratings-div-1752672977568-12"
            >
                <!---->
                <div
                    class="ui-star filled ng-star-inserted"
                    data-testid="t-ratings-div-1752672977568-7"
                >
                    <i
                        class="oc-star-filled"
                        data-testid="t-ratings-i-1752672977568-1"
                    ></i>
                    <i
                        class="oc-star-filled"
                        data-testid="t-ratings-i-1752672977568-2"
                    ></i>
                </div>
                <div
                    class="ui-star filled ng-star-inserted"
                    data-testid="t-ratings-div-1752672977568-8"
                >
                    <i
                        class="oc-star-filled"
                        data-testid="t-ratings-i-1752672977568-3"
                    ></i>
                    <i
                        class="oc-star-filled"
                        data-testid="t-ratings-i-1752672977568-4"
                    ></i>
                </div>
                <div
                    class="ui-star filled ng-star-inserted"
                    data-testid="t-ratings-div-1752672977568-9"
                >
                    <i
                        class="oc-star-filled"
                        data-testid="t-ratings-i-1752672977568-5"
                    ></i>
                    <i
                        class="oc-star-filled"
                        data-testid="t-ratings-i-1752672977568-6"
                    ></i>
                </div>
                <div
                    class="ui-star filled ng-star-inserted"
                    data-testid="t-ratings-div-1752672977568-10"
                >
                    <i
                        class="oc-star-filled"
                        data-testid="t-ratings-i-1752672977568-7"
                    ></i>
                    <i
                        class="oc-star-filled"
                        data-testid="t-ratings-i-1752672977568-8"
                    ></i>
                </div>
                <div
                    class="ui-star half-filled ng-star-inserted"
                    data-testid="t-ratings-div-1752672977568-11"
                >
                    <i
                        class="oc-star-filled"
                        data-testid="t-ratings-i-1752672977568-9"
                    ></i>
                    <i
                        class="oc-star-filled"
                        data-testid="t-ratings-i-1752672977568-10"
                    ></i>
                </div>
            </div>
        </div>
    </div>
    <a
        class="mx-auto d-block text-muted small"
        href="javascript:void(0)"
        data-testid="t-ratings-a-1752672977568-1"
        >120 {{ 'mws.ratings' | i18n }} | 2 {{ 'mws.costcenters' | i18n }}</a
    >
</div>

<br data-testid="t-ratings-br-1752672977568-2" />
<div
    class="separator mb-3"
    data-testid="t-ratings-div-1752672977568-16"
>
    &nbsp;{{ 'mws.supplierratings' | i18n }}&nbsp;
</div>

<div
    class="table-responsive table-oc-responsive"
    data-testid="t-ratings-div-1752672977568-31"
>
    <table
        class="table"
        data-testid="t-ratings-table-1752672977568-1"
    >
        <thead data-testid="t-ratings-thead-1752672977568-1">
            <tr data-testid="t-ratings-tr-1752672977568-1">
                <th
                    class="text-nowrap cursor-pointer"
                    data-testid="t-ratings-th-1752672977568-1"
                >
                    {{ 'mws.costcenter' | i18n }}
                </th>
                <th
                    class="text-nowrap cursor-pointer"
                    data-testid="t-ratings-th-1752672977568-2"
                >
                    {{ 'mws.averagerating' | i18n }}
                </th>
                <th
                    class="text-nowrap cursor-pointer"
                    data-testid="t-ratings-th-1752672977568-3"
                >
                    {{ 'mws.allratings' | i18n }}
                </th>
            </tr>
        </thead>
        <tbody data-testid="t-ratings-tbody-1752672977568-1">
            <tr
                class="ng-star-inserted"
                data-testid="t-ratings-tr-1752672977568-2"
            >
                <td
                    class="align-middle"
                    data-testid="t-ratings-td-1752672977568-1"
                >
                    <span
                        href="javascript:void(0)"
                        data-testid="t-ratings-span-1752672977568-2"
                        >Küche Nord Zenral Haus 1</span
                    >
                </td>
                <td
                    class="align-middle"
                    data-testid="t-ratings-td-1752672977568-2"
                >
                    <div
                        class="message-date text-muted"
                        data-testid="t-ratings-div-1752672977568-23"
                    >
                        <div
                            class="ui-stars text-large text-nowrap"
                            data-testid="t-ratings-div-1752672977568-22"
                        >
                            <!---->
                            <div
                                class="ui-star filled ng-star-inserted"
                                data-testid="t-ratings-div-1752672977568-17"
                            >
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-11"
                                ></i>
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-12"
                                ></i>
                            </div>
                            <div
                                class="ui-star filled ng-star-inserted"
                                data-testid="t-ratings-div-1752672977568-18"
                            >
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-13"
                                ></i>
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-14"
                                ></i>
                            </div>
                            <div
                                class="ui-star filled ng-star-inserted"
                                data-testid="t-ratings-div-1752672977568-19"
                            >
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-15"
                                ></i>
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-16"
                                ></i>
                            </div>
                            <div
                                class="ui-star filled ng-star-inserted"
                                data-testid="t-ratings-div-1752672977568-20"
                            >
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-17"
                                ></i>
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-18"
                                ></i>
                            </div>
                            <div
                                class="ui-star half-filled ng-star-inserted"
                                data-testid="t-ratings-div-1752672977568-21"
                            >
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-19"
                                ></i>
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-20"
                                ></i>
                            </div>
                        </div>
                        <a
                            class="d-block text-muted small"
                            href="javascript:void(0)"
                            data-testid="t-ratings-a-1752672977568-2"
                            >60 {{ 'mws.ratings' | i18n }}</a
                        >
                    </div>
                </td>
                <td
                    class="text-end"
                    data-testid="t-ratings-td-1752672977568-3"
                >
                    <a
                        (click)="openCustomerratingsModal()"
                        class="mx-auto btn-sm btn btn-primary action--btn"
                        [attr.aria-label]="'mws.details' | i18n"
                        data-testid="t-ratings-a-1752672977568-3"
                        ><i
                            class="oc-general-info"
                            data-testid="t-ratings-i-1752672977568-21"
                        ></i
                    ></a>
                </td>
            </tr>
            <tr
                class="ng-star-inserted"
                data-testid="t-ratings-tr-1752672977568-3"
            >
                <td
                    class="align-middle"
                    data-testid="t-ratings-td-1752672977568-4"
                >
                    <span
                        href="javascript:void(0)"
                        data-testid="t-ratings-span-1752672977568-3"
                        >Küche Nord Zenral Haus 2</span
                    >
                </td>
                <td
                    class="align-middle"
                    data-testid="t-ratings-td-1752672977568-5"
                >
                    <div
                        class="message-date text-muted"
                        data-testid="t-ratings-div-1752672977568-30"
                    >
                        <div
                            class="ui-stars text-large text-nowrap"
                            data-testid="t-ratings-div-1752672977568-29"
                        >
                            <!---->
                            <div
                                class="ui-star filled ng-star-inserted"
                                data-testid="t-ratings-div-1752672977568-24"
                            >
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-22"
                                ></i>
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-23"
                                ></i>
                            </div>
                            <div
                                class="ui-star filled ng-star-inserted"
                                data-testid="t-ratings-div-1752672977568-25"
                            >
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-24"
                                ></i>
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-25"
                                ></i>
                            </div>
                            <div
                                class="ui-star filled ng-star-inserted"
                                data-testid="t-ratings-div-1752672977568-26"
                            >
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-26"
                                ></i>
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-27"
                                ></i>
                            </div>
                            <div
                                class="ui-star filled ng-star-inserted"
                                data-testid="t-ratings-div-1752672977568-27"
                            >
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-28"
                                ></i>
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-29"
                                ></i>
                            </div>
                            <div
                                class="ui-star half-filled ng-star-inserted"
                                data-testid="t-ratings-div-1752672977568-28"
                            >
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-30"
                                ></i>
                                <i
                                    class="oc-star-filled"
                                    data-testid="t-ratings-i-1752672977568-31"
                                ></i>
                            </div>
                        </div>
                        <a
                            class="d-block text-muted small"
                            href="javascript:void(0)"
                            data-testid="t-ratings-a-1752672977568-4"
                            >60 {{ 'mws.ratings' | i18n }}</a
                        >
                    </div>
                </td>
                <td
                    class="text-end"
                    data-testid="t-ratings-td-1752672977568-6"
                >
                    <a
                        (click)="openCustomerratingsModal()"
                        class="mx-auto btn-sm btn btn-primary action--btn"
                        [attr.aria-label]="'mws.details' | i18n"
                        data-testid="t-ratings-a-1752672977568-5"
                        ><i
                            class="oc-general-info"
                            data-testid="t-ratings-i-1752672977568-32"
                        ></i
                    ></a>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<ng-template
    #customerratingsModal
    let-c="close"
    let-d="dismiss"
>
    <app-customerratings
        [modalMessageTitle]="'mws.ratings' | i18n"
        [c]="c"
        [d]="d"
        data-testid="t-ratings-app-customerratings-1752672977568-1"
    />
</ng-template>

<!--<tr class="ng-star-inserted">-->
<!--    <td class="align-middle">-->
<!--        <a href="javascript:void(0)">Küche Nord Zenral Haus 2</a>-->
<!--    </td>-->
<!--    <td class="align-middle">-->
<!--        <div class="message-date text-muted">-->
<!--            <div class="ui-stars text-large text-nowrap">-->
<!--                &lt;!&ndash;&ndash;&gt;-->
<!--                <div class="ui-star filled ng-star-inserted">-->
<!--                    <i class="oc-star-filled"></i>-->
<!--                    <i class="oc-star-filled"></i>-->
<!--                </div>-->
<!--                <div class="ui-star filled ng-star-inserted">-->
<!--                    <i class="oc-star-filled"></i>-->
<!--                    <i class="oc-star-filled"></i>-->
<!--                </div>-->
<!--                <div class="ui-star filled ng-star-inserted">-->
<!--                    <i class="oc-star-filled"></i>-->
<!--                    <i class="oc-star-filled"></i>-->
<!--                </div>-->
<!--                <div class="ui-star filled ng-star-inserted">-->
<!--                    <i class="oc-star-filled"></i>-->
<!--                    <i class="oc-star-filled"></i>-->
<!--                </div>-->
<!--                <div class="ui-star half-filled ng-star-inserted">-->
<!--                    <i class="oc-star-filled"></i>-->
<!--                    <i class="oc-star-filled"></i>-->
<!--                </div>-->
<!--            </div>-->
<!--            <a class="d-block text-muted small" href="javascript:void(0)">123 Bewertungen</a>-->
<!--        </div>-->
<!--    </td>-->
<!--    <td class="align-middle">f.blume</td>-->
<!--    <td class="align-middle">01.03.2020</td>-->
<!--</tr>-->

<!--    <div class="row m-0">-->
<!--        <div class="col-5 m-0 p-0" style="border-right: 5px solid #144263">-->
<!--            <div class="table-responsive">-->
<!--                <table class="table card-table m-0 borderless">-->
<!--                    <tr class="ng-star-inserted">-->
<!--                        <td class="borderless">-->
<!--                            <span>Klinik Nord</span>-->
<!--                        </td>-->
<!--                        <td class="text-end borderless">-->
<!--                            <div class="message-date text-muted">-->
<!--                                <div class="ui-stars text-large text-nowrap">-->
<!--                                    &lt;!&ndash;&ndash;&gt;-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star half-filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr class="ng-star-inserted">-->
<!--                        <td class="borderless">-->
<!--                            <span>Klinik Nord</span>-->
<!--                        </td>-->
<!--                        <td class="text-end borderless">-->
<!--                            <div class="message-date text-muted">-->
<!--                                <div class="ui-stars text-large text-nowrap">-->
<!--                                    &lt;!&ndash;&ndash;&gt;-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star half-filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                </table>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="col-7 m-0 p-0">-->
<!--            <div class="table-responsive">-->
<!--                <table class="table card-table m-0 borderless">-->
<!--                    <tr class="ng-star-inserted">-->
<!--                        <td class="text-muted borderless">-->
<!--                            <i>F.Blume, 1.1.2020</i>-->
<!--                        </td>-->

<!--                        <td class="text-end borderless">-->
<!--                            <div class="message-date text-muted">-->
<!--                                <div class="ui-stars text-large text-nowrap">-->
<!--                                    &lt;!&ndash;&ndash;&gt;-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star half-filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr class="ng-star-inserted">-->
<!--                        <td class="text-muted borderless">-->
<!--                            <i>S.Walter, 1.1.2020</i>-->
<!--                        </td>-->

<!--                        <td class="text-end borderless">-->
<!--                            <div class="message-date text-muted">-->
<!--                                <div class="ui-stars text-large text-nowrap">-->
<!--                                    &lt;!&ndash;&ndash;&gt;-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                    <tr class="ng-star-inserted">-->
<!--                        <td class="text-muted borderless">-->
<!--                            <i>S.Rutenkolk, 1.1.2020</i>-->
<!--                        </td>-->

<!--                        <td class="text-end borderless">-->
<!--                            <div class="message-date text-muted">-->
<!--                                <div class="ui-stars text-large text-nowrap">-->
<!--                                    &lt;!&ndash;&ndash;&gt;-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                    <div class="ui-star filled ng-star-inserted">-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                        <i class="oc-star-filled"></i>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                </table>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
